import { useEffect } from "react";
import LocaleRouter from "../routers/LocaleRouter";
import { store, persistor } from "../store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../api/client";
import { initializeAuthFromStorage } from "../utils/auth/initializeAuth";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../theme/theme";

const AppContent = () => {
  useEffect(() => {
    // Initialize auth from localStorage after PersistGate has loaded
    initializeAuthFromStorage();
  }, []);

  return <LocaleRouter />;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <PersistGate
          loading={null}
          persistor={persistor}
          onBeforeLift={() => {
            initializeAuthFromStorage();
          }}
        >
          <AppContent />
        </PersistGate>
      </ThemeProvider>
    </Provider>
  </QueryClientProvider>
);

export default App;
